var _circle, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#D680FF"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "url(#paint0_radial)",
    style: {
      mixBlendMode: "darken"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.2022 75.1931C68.544 75.1931 67.8984 74.9526 67.3794 74.4716C62.9237 70.3197 56.8605 67.8893 50.3035 67.6361C43.0123 67.3577 36.0756 69.8387 31.2529 74.4463C30.1896 75.4716 28.4934 75.4209 27.468 74.3577C26.4427 73.2944 26.4807 71.5855 27.5567 70.5728C33.4174 64.9779 41.7972 61.9526 50.506 62.2817C58.3415 62.5855 65.6326 65.5096 71.0377 70.5475C72.1263 71.5602 72.1769 73.2564 71.1769 74.3323C70.6326 74.9146 69.9237 75.1931 69.2022 75.1931Z",
    fill: "#030822"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.38 59.5221C82.2155 59.5221 82.0509 59.4968 81.8737 59.4461L70.2408 56.0537C69.5446 55.8512 69.0382 55.2436 68.9623 54.5094C68.8863 53.7879 69.2661 53.0917 69.9243 52.7499C69.9243 52.7499 78.975 48.0664 81.6838 46.6234C82.5572 46.155 83.6332 46.4841 84.1015 47.3575C84.5699 48.2309 84.2408 49.3069 83.3674 49.7753C81.8484 50.5854 78.3294 52.4208 75.5319 53.8639L82.8863 56.0158C83.8357 56.2942 84.38 57.2816 84.1015 58.2309C83.861 59.0158 83.1522 59.5221 82.38 59.5221Z",
    fill: "#030822"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7347 59.5218C15.9625 59.5218 15.2537 59.0155 15.0258 58.2307C14.7473 57.2813 15.2916 56.294 16.241 56.0155L23.5954 53.8636C20.798 52.4079 17.279 50.5851 15.76 49.775C14.8866 49.3066 14.5575 48.2307 15.0258 47.3573C15.4942 46.4838 16.5701 46.1547 17.4435 46.6231C20.1524 48.0661 29.203 52.7497 29.203 52.7497C29.8486 53.0914 30.2283 53.7876 30.165 54.5092C30.0891 55.2307 29.5828 55.8509 28.8866 56.0535L17.2537 59.4459C17.0638 59.4965 16.8992 59.5218 16.7347 59.5218Z",
    fill: "#030822"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0141 40.4963C84.9255 40.4963 84.8369 40.4837 84.7356 40.471C75.8242 39.0913 71.3559 31.8761 71.166 31.5596C70.6596 30.7115 70.9255 29.6229 71.7609 29.1039C72.609 28.5849 73.6976 28.8634 74.2166 29.6989C74.2799 29.8001 78.0774 35.8128 85.2799 36.9267C86.2546 37.0786 86.9255 37.99 86.7736 38.9647C86.647 39.8634 85.8875 40.4963 85.0141 40.4963Z",
    fill: "#030822"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0886 40.496C13.2278 40.496 12.4683 39.8631 12.3291 38.977C12.1772 38.0023 12.8481 37.0909 13.8227 36.939C21.1012 35.8124 24.8354 29.7744 24.8734 29.7112C25.3797 28.8631 26.481 28.5972 27.3291 29.1162C28.1772 29.6352 28.443 30.7238 27.924 31.5719C27.7468 31.8757 23.2658 39.0909 14.3671 40.4707C14.2658 40.4833 14.1772 40.496 14.0886 40.496Z",
    fill: "#030822"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.25 40.7692) rotate(96.0235) scale(59.5596 59.5396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.854067,
    stopColor: "#FFBB54",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#FFDA54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854267,
    stopColor: "#FFBB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854367,
    stopColor: "#8E59FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854467,
    stopColor: "#9859FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854567,
    stopColor: "#AB68FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwful);
export default __webpack_public_path__ + "static/media/Awful.2100c89405302c589d2f44d0a375d8fe.svg";
export { ForwardRef as ReactComponent };